export const packageData = {
  title: 'Infrastructure Growth Package',
  subtitle:
    'A connected implementation package designed to help organizations improve hiring, modernize websites, reduce repetitive workflows, implement AI systems, and strengthen operational infrastructure.',
  startingPrice: '$50,000',
  ctaText: 'View Package Details',
  ctaLink: 'https://mainframesolutions.net/infrastructure-growth-package/',
  included: [
    'One critical hire through executive search',
    'BuildFit AI evaluation integration',
    'Website development',
    'AI workflow implementation',
    'Operational infrastructure consultation',
  ],
  outcomes: [
    'Reduced mis-hires',
    'Modernized systems',
    'Structured AI governance',
    'Scalable infrastructure',
  ],
  footerNote:
    'Designed for organizations ready to modernize their operational backbone in 90 days.',
};